<button
  type="button"
  class="chip"
  [class.chip-selected]="isSelected"
  [disabled]="isDisabled"
  [attr.aria-pressed]="isSelected"
  [attr.aria-label]="label"
  (click)="toggle()"
>
  <mat-icon *ngIf="svgIconName" class="chip-icon" [svgIcon]="svgIconName" aria-hidden="true"></mat-icon>
  <mat-icon *ngIf="!svgIconName && iconName" class="chip-icon" fontSet="material-symbols-outlined" aria-hidden="true">
    {{ iconName }}
  </mat-icon>
  <span class="chip-label">{{ label }}</span>
</button>
